var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 0.713379V6.00005H11.3334C11.3334 3.28005 9.30008 1.04005 6.66675 0.713379ZM0.666748 10C0.666748 12.9467 3.05341 15.3334 6.00008 15.3334C8.94675 15.3334 11.3334 12.9467 11.3334 10V7.33338H0.666748V10ZM5.33342 0.713379C2.70008 1.04005 0.666748 3.28005 0.666748 6.00005H5.33342V0.713379Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseIcon);
export default __webpack_public_path__ + "static/media/MouseIcon.d905f86c.svg";
export { ForwardRef as ReactComponent };